<script>
import moment from "@/utils/moment";
import orderMixin from "@/mixins/orderMixin";
import countdownMixin from "@/mixins/countdownMixin";
import dateAndTimeMixin from "@/mixins/generic/dateAndTimeMixin";

import ProgressBar from "@/components/_base/ProgressBar";

export default {
  mixins: [orderMixin, countdownMixin, dateAndTimeMixin],

  components: {
    ProgressBar
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  methods: {
    endingAt() {
      return moment(this.order.updated_at).add(
        this.$options.filters.fromMinutesToHours(
          this.order.schedule_event.duration
        ),
        "hours"
      );
    }
  },

  computed: {
    isProvisioning: function() {
      return this.isOrderProvisioning(this.order);
    },

    orderNotInitialized: function() {
      return (
        this.isOrderPaid(this.order) && this.daysBeforeOrder(this.order) < 0
      );
    }
  },

  mounted() {
    if (this.isProvisioning) {
      this.startCountDown(
        this.order.updated_at,
        this.order.schedule_event.duration * 60
      );
    }
  }
};
</script>
<template>
  <div class="body">
    <span class="description">
      Detalhes da limpeza
    </span>

    <div class="body-content">
      <div class="date">
        <img src="/static/calendar-outlined.svg" />
        <span>{{ order | getOrderScheduleDay }}</span>
      </div>

      <div class="duration">
        <img src="/static/clock-outlined.svg" />
        <span>{{ order | getOrderDuration }}</span>
      </div>

      <div class="location">
        <img src="/static/pin.svg" />
        <span>{{ order | getOrderAddressName }}</span>
      </div>
    </div>

    <div class="order-countdown" v-if="isProvisioning">
      <ProgressBar :progress="percentageTimeCompleted()" />

      <div class="progress-text">
        <div class="starting">
          <span>iniciado às</span>
          <span>{{ order.updated_at | formatDate("DD/MM HH:mm:ss") }}</span>
        </div>

        <div class="ending">
          <span>término estimado</span>
          <span>{{ endingAt() | formatDate("DD/MM HH:mm:ss") }}</span>
        </div>
      </div>

        <div class="alert-message">
          <img src="/static/exclamation-triangle-solid.svg" />

          Os horários mostrados aqui podem variar de acordo com a hora em que limpeza foi iniciada pelo profissional.
        </div>
    </div>

    <div class="alert-message" v-if="orderNotInitialized">
      <img src="/static/exclamation-triangle-solid.svg" />

      Entre em contato com o nosso suporte caso a limpeza não tenha sido realizada.
    </div>
  </div>
</template>

<style scoped>
.body {
  width: 100%;
  margin-top: 16px;
  padding: 12px 0;
  position: relative;
  border: solid 1px #e2e2e2;
  border-left: none;
  border-right: none;
}

.description {
  position: absolute;
  top: -8px;
  padding-right: 8px;
  font-size: 12px;
  font-weight: 400;
  background-color: #fff;
}

.body-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
}

.body-content img {
  width: 14px;
  margin-right: 4px;
}

.date,
.duration,
.location {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

.order-countdown {
  margin-top: 16px;
}

.progress-text {
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
}

.progress-text > .starting {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.progress-text > .starting > span:nth-child(2) {
  font-weight: 400;
}

.progress-text > .ending {
  display: flex;
  flex-direction: column;
  text-align: end;
}

.progress-text > .ending > span:nth-child(2) {
  font-weight: 400;
}

.alert-message {
  margin-top: 8px;
  font-size: 12px;
}

.alert-message > img {
  width: 14px;
  height: 12px;
  filter: invert(9%) sepia(94%) saturate(5820%) hue-rotate(316deg)
    brightness(88%) contrast(102%);
}

.alert-message > span > b {
  font-weight: 400;
  color: #603285;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Card/Body.vue